import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Input } from '../../../components/UI/ComponentsUI';
import { labelsPlant, translate, formatData, isNullOrEmpty } from '../../../utils/util';

const ItemSpaceXD = (props) => {
    const checkedItem = (item) => {
        var itema = props.labels.find(f => f.id === item.id);
        return itema || false;

    }

    return (
        <div
            className="row"
            style={{ color: 'black', display: 'block', marginBottom: '0px', marginLeft: '0px' }}
            key={`oi-${props.item.id}`}
        >
            <div className="title black-text col s12" style={{ padding: '0px' }}>{props.item.receipt.partNumberCode}</div>
            <div className="col s12" style={{ padding: '0px' }}>CIM: {props.item.cim}</div>
            {
                !isNullOrEmpty(props.item.masterCim) &&
                <div className="col s12" style={{ padding: '0px' }}>Master CIM: {props.item.masterCim}</div>
            }
            {
                !isNullOrEmpty(props.item.cimPallet) &&
                <div className="col s12" style={{ padding: '0px' }}>CIM Pallet: {props.item.cimPallet}</div>
            }
            <div className="col s12" style={{ padding: '0px' }}>{props.item.partNumberDescription}</div>
            <div className="col s12" style={{ padding: '0px' }}>{`${translate('truck-kanban:mvm')}: ${props.item.receipt.mvmNumber}`}</div>
            <div className="col s12" style={{ padding: '0px' }}>{`${translate('physical-confirmation:journey')}: ${props.item.receipt.journey}`}</div>
            <div className="col s12" style={{ padding: '0px' }}>{`${translate('truck-kanban:supplier')}: ${props.item.receipt.supplier || ''}`}</div>
            <div className="col s12" style={{ padding: '0px' }}>{`${translate('truck-kanban:destination-shed')}: ${props.item.receipt.shed}`}</div>
            <div className="col s7" style={{ padding: '0px' }}>{`${translate('truck-kanban:destination-company')}: ${labelsPlant(`${props.item.receipt.companyId}-${props.item.receipt.warehouseId}`)}`}</div>
            <div className="col s5" style={{ padding: '0px' }}>{`${translate('truck-kanban:amount-received')}: ${(props.item.quantity || 0)} `}</div>
            <div className="col s7" style={{ padding: '0px' }}>{`${translate('truck-kanban:invoice-number')}: ${props.item.receipt.invoice}`}</div>
            <div className="col s7" style={{ padding: '0px' }}>{`${'Pallet'}: ${props.item.idPallet}`}</div>
            <div className="col s5" style={{ padding: '0px' }}>{`${formatData(props.item.createdOn)} `}</div>

            <div className="col s12" style={{ padding: '0px' }}>{`${translate('truck-kanban:observation')}: ${!isNullOrEmpty(props.item.observation) ? props.item.observation : ""}`}</div>
            <span
                className="title sixth-text-color right"
                style={{ position: 'absolute', marginTop: '10px', right: '20px' }}
            >
                <Input type="checkbox" id={props.item.id}
                    defaultChecked={checkedItem(props.item)}
                    name={props.item.id}
                    onChange={(event) => {
                        const addItem = {
                            partNumberCode: props.item.receipt.partNumberCode,
                            partNumberDescription: props.item.receipt.partNumberDescription,
                            mvmNumber: props.item.receipt.mvmNumber,
                            ...props.item
                        }


                        props.addMviItem(addItem, event)
                    }} />
            </span>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        labels: state.truckKanbanReducer.labels
    };
};

const mapDispatchToProps = () => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ItemSpaceXD));